"use strict";

var asyncWhile = function asyncWhile(promise, action) {
  return new Promise(function (resolve, reject) {
    var interval = setInterval(action, 0);
    promise.then(function (data) {
      clearInterval(interval);
      resolve(data);
    }, function (error) {
      clearInterval(interval);
      reject(error);
    });
  });
};

module.exports = asyncWhile;


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/promise/asyncWhile.js
// module id = 2195
// module chunks = 37